import { render, staticRenderFns } from "./InviteUserProject.vue?vue&type=template&id=474fa2ce&scoped=true&"
import script from "./InviteUserProject.vue?vue&type=script&lang=js&"
export * from "./InviteUserProject.vue?vue&type=script&lang=js&"
import style0 from "./InviteUserProject.vue?vue&type=style&index=0&id=474fa2ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fa2ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
